export const NavMenuItems = [
  { title: "Home", url: "/", cName: "nav-links" },
  { title: "Explore", url: "/explore", cName: "nav-links" },
  { title: "Science", url: "/science", cName: "nav-links" },
  { title: "Reviews", url: "/reviews", cName: "nav-links" },
];
